import "boxicons";
import React, { useState, useEffect } from "react";
import { BgCanvas } from '../components/canvas';
// import { BackButton } from "../components/backButton";
import { useNavigate } from "react-router-dom";

import { Box, Container } from '@mui/system';
import Grid from '@mui/system/Grid';
import { alignProperty } from "@mui/material/styles/cssUtils";

export default function ThankYou(){
  const navigate = useNavigate();
   useEffect(()=>{
          BgCanvas()
      },0)
  const navigateHome = ()=>{
    navigate('/home');
  }
  const navigateLogin = ()=>{
    navigate('/students-login');
  }

    return(
        <>
        <section className="canvas-element" id='canvas-element'>
        </section>
        <Container>
        <div className="thankyou parentdiv">
             <Box sx={{ flexGrow: 1 }}>
             {/* display:"flex", justifyContent:"center", flexWrap:"nowrap", flexDirection:"row" */}
             <Grid item xs={12} md={12} sx={{flexDirection:"row"}} className="heading">  
                <h1>Thank You!!</h1>
             </Grid>
<Grid item xs={12} md={12}  sx={{flexDirection:"row", justifyContent:"center"}}>
<h2>Thank you for registering!  A confirmation email has been sent to email address. 
<br /> Click the button below to Login and access your account.
  </h2>
  
  <p>
    <button onClick={navigateLogin} className="btn btn-lg mt-20"><span>Login</span></button>
    <button onClick={navigateHome} className="btn btn-lg ml-20"><span>Home</span></button>
  </p>


</Grid>
<Grid item xs={12} md={12} sx={{flexDirection:"row",justifyContent:"center", display:"flex"}}>
{/* <svg width="287" height="278" viewBox="0 0 157 150" fill="none" xmlns="http://www.w3.org/2000/svg">
  <ellipse class="shaddow" cx="78.5" cy="143" rx="60" ry="7" fill="black" fill-opacity="0.47"></ellipse>
  <g class="star">
    <path d="M73.4975 57.291C75.171 53.033 79.829 53.033 81.5025 57.291L90.455 76.2165C91.1085 77.488 92.327 78.374 93.7385 78.602L113.078 81.7315C116.694 82.3165 118.1325 87.2465 115.5515 89.345L101.7455 104.244C100.7375 105.122 100.272 106.691 100.491 108.104L103.491 128.464C104.0515 132.5835 100.2835 135.821 97.0145 133.669L79.5295 124.3335C78.2535 123.6885 76.7465 123.6885 75.4705 124.3335L57.9855 133.669C54.7165 135.821 50.9485 132.5835 51.509 128.464L54.509 108.104C54.728 106.691 54.2625 105.122 53.2545 104.244L39.4485 89.345C36.8675 87.2465 38.306 82.3165 41.922 81.7315L61.2615 78.602C62.673 78.374 63.8915 77.488 64.545 76.2165L73.4975 57.291Z" fill="#FFF96D"></path>
    <path d="M81.2805 57.4055L90.2325 76.331C90.922 77.673 92.209 78.608 93.699 78.849L113.039 81.9785C116.4525 82.531 117.812 87.2145 115.374 89.169L101.5685 104.068C100.504 104.938 100.013 106.651 100.244 108.142L103.244 128.502C103.7735 132.4205 100.2145 135.006 97.127 133.446L79.642 124.111C78.295 123.4295 76.705 123.4295 75.358 124.111L57.873 133.446C54.7855 135.006 51.2265 132.4205 51.756 128.502L54.756 108.142C54.987 106.651 54.496 104.938 53.4315 104.068L39.626 89.169C37.188 87.2145 38.5475 82.531 41.961 81.9785L61.301 78.849C62.791 78.608 64.078 77.673 64.7675 76.331L73.7195 57.4055C75.3005 54.828 79.6995 54.828 81.2805 57.4055Z" stroke="black" stroke-opacity="0.26"></path>
    <circle cx="67" cy="85.5" r="9" fill="black"></circle>
    <circle cx="88.5" cy="85.5" r="9" fill="black"></circle>
    <circle cx="65.5" cy="83.5" r="1" fill="white"></circle>
    <circle cx="87" cy="83.5" r="1" fill="white"></circle>
    <mask id="path-9-inside-1" fill="white">
      <path d="M86 97.5C86 99.6215 85.157 101.6565 83.657 103.157C82.157 104.6575 80.1215 105.5 78 105.5C75.8785 105.5 73.843 104.6575 72.343 103.157C70.843 101.6565 70 99.6215 70 97.5L78 97.5H86Z"></path>
    </mask>
    <path class="mouth" d="M86 97.5C86 99.6215 85.157 101.6565 83.657 103.157C82.157 104.6575 80.1215 105.5 78 105.5C75.8785 105.5 73.843 104.6575 72.343 103.157C70.843 101.6565 70 99.6215 70 97.5L78 97.5H86Z" fill="#FF331F" stroke="black" stroke-opacity="0.42" stroke-width="2" mask="url(#path-9-inside-1)"></path>
  </g>
  <defs>
    <radialGradient id="paint0_radial" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(20.25 21) rotate(90) scale(18 20.25)">
      <stop stop-color="white"></stop>
      <stop offset="2" stop-color="white" stop-opacity="0.33"></stop>
    </radialGradient>
  </defs>
</svg> */}
<svg width="130" height="120" viewBox="0 0 287 278" fill="none" xmlns="http://www.w3.org/2000/svg">
    <ellipse class="shaddow" cx="155" cy="257" rx="60" ry="7" fill="black" fill-opacity="0.47" />
  <g class="star">
    <path d="M146.995 107.582C150.342 101.066 159.658 101.066 163.005 107.582L180.91 142.433C182.217 144.976 184.654 146.748 187.477 147.204L226.155 153.463C233.387 154.633 236.265 163.493 231.103 168.69L203.491 196.488C201.475 198.516 200.544 201.382 200.982 204.208L206.982 242.927C208.103 250.167 200.567 255.642 194.029 252.338L159.059 234.667C156.507 233.377 153.493 233.377 150.941 234.667L115.971 252.338C109.433 255.642 101.897 250.167 103.018 242.927L109.018 204.208C109.456 201.382 108.525 198.516 106.509 196.488L78.8975 168.69C73.7346 163.493 76.6131 154.633 83.845 153.463L122.523 147.204C125.346 146.748 127.783 144.976 129.09 142.433L146.995 107.582Z" fill="#FFF96D" />
    
    <path d="M162.561 107.811L180.465 142.661C181.844 145.346 184.418 147.216 187.398 147.698L226.075 153.957C232.905 155.062 235.624 163.429 230.748 168.338L203.136 196.135C201.008 198.277 200.026 201.302 200.488 204.285L206.487 243.003C207.547 249.841 200.429 255.012 194.254 251.892L159.285 234.221C156.59 232.859 153.41 232.859 150.715 234.221L115.746 251.891C109.571 255.012 102.453 249.841 103.513 243.003L109.512 204.285C109.974 201.302 108.992 198.277 106.864 196.135L79.2522 168.338C74.3761 163.429 77.0948 155.062 83.9249 153.957L122.602 147.698C125.582 147.216 128.156 145.346 129.535 142.661L147.439 107.811C150.601 101.656 159.399 101.656 162.561 107.811Z" stroke="black" stroke-opacity="0.26" />
    <circle cx="134" cy="171" r="9" fill="black" />
    <circle cx="177" cy="171" r="9" fill="black" />
    <circle cx="131" cy="167" r="1" fill="white" />
    <circle cx="174" cy="167" r="1" fill="white" />
    <mask id="path-9-inside-1" fill="white">
      <path d="M172 195C172 199.243 170.314 203.313 167.314 206.314C164.313 209.314 160.243 211 156 211C151.757 211 147.687 209.314 144.686 206.314C141.686 203.313 140 199.243 140 195L156 195H172Z" />
    </mask>
    <path class="mouth" d="M172 195C172 199.243 170.314 203.313 167.314 206.314C164.313 209.314 160.243 211 156 211C151.757 211 147.687 209.314 144.686 206.314C141.686 203.313 140 199.243 140 195L156 195H172Z" fill="#FF331F" stroke="black" stroke-opacity="0.42" stroke-width="2" mask="url(#path-9-inside-1)" />
  </g>
  
  <defs>
    <radialGradient id="paint0_radial" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(40.5 42) rotate(90) scale(36 40.5)">
      <stop stop-color="white" />
      <stop offset="2" stop-color="white" stop-opacity="0.33" />
    </radialGradient>
  </defs>
</svg>
</Grid>

</Box>
</div>    </Container>

        </>
    )
}